module.exports = __webpack_public_path__ + "static/mountains-7f8643cf914c14e500b4dadb03eebd54.svg";